/**
 * Subscription-first buy box (from A/B test)
 */
(function () {
  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function initBuybox(buybox) {
    var productForm = buybox.closest('form');
    var dataEl = buybox.querySelector('[data-cc-buybox-json]');
    if (!productForm || !dataEl) return;

    var data = JSON.parse(dataEl.textContent);
    var variantSelect = productForm.querySelector('select[name="id"]');
    var quantityInput = buybox.querySelector('[data-cc-quantity]');
    var ctaButton = buybox.querySelector('[data-cc-cta]');

    function getVariant() {
      var id = Number(variantSelect ? variantSelect.value : 0);
      return data.variants.find(function (v) { return v.id === id; }) || data.variants[0];
    }

    function getPurchaseType() {
      var checked = buybox.querySelector('input[name="cc-buybox-purchase-type"]:checked');
      return checked ? checked.value : 'subscribe';
    }

    function getSelectedPlan() {
      return buybox.querySelector('input[name="cc-buybox-selling-plan"]:checked');
    }

    function getPlanPrice(variant, planId) {
      var price = variant.plans[String(planId)];
      return typeof price === 'number' ? price : variant.price;
    }

    function getQuantity() {
      return Math.max(1, parseInt(quantityInput.value, 10) || 1);
    }

    function setText(selector, text) {
      var el = buybox.querySelector(selector);
      if (el) el.textContent = text;
    }

    function update() {
      var variant = getVariant();
      var plan = getSelectedPlan();
      var subscribePrice = getPlanPrice(variant, plan && plan.value);
      var isSubscribe = getPurchaseType() === 'subscribe';

      setText('[data-cc-once-price]', formatMoney(variant.price));
      setText('[data-cc-subscribe-price]', formatMoney(subscribePrice));
      setText('[data-cc-compare-price]', formatMoney(variant.price));
      var savings = Math.max(0, variant.price - subscribePrice);
      var savingsPercent = variant.price > 0 ? Math.round((savings / variant.price) * 100) : 0;
      setText('[data-cc-savings]', formatMoney(savings));
      setText('[data-cc-badge]', 'Save ' + savingsPercent + '%');
      buybox.querySelector('[data-cc-badge]').hidden = savingsPercent === 0;
      setText(
        '[data-cc-once-description]',
        variant.option2
          ? 'A single ' + variant.option2.toLowerCase() + ' bag, no commitment'
          : 'A single bag, no commitment'
      );

      buybox.querySelectorAll('.cc-buybox__frequency-option').forEach(function (option) {
        var input = option.querySelector('input');
        option.querySelector('[data-cc-plan-price]').textContent = formatMoney(
          getPlanPrice(variant, input.value)
        );
      });

      ctaButton.disabled = !variant.available;
      if (!variant.available) {
        ctaButton.textContent = data.soldOut;
      } else if (isSubscribe) {
        ctaButton.textContent =
          'Subscribe · ' + formatMoney(subscribePrice * getQuantity()) + ' ' + plan.dataset.planInterval;
      } else {
        ctaButton.textContent = 'Add to cart · ' + formatMoney(variant.price * getQuantity());
      }
    }

    var successModal = buybox.querySelector('[data-cc-success-modal]');

    function showSuccessModal() {
      successModal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      successModal.querySelector('[data-cc-success-close]').focus();
    }

    function hideSuccessModal() {
      successModal.style.display = 'none';
      document.body.style.overflow = '';
      ctaButton.focus();
    }

    function updateCartCount() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function (error) {
          console.error('Error updating cart count:', error.message);
        });
    }

    function addToCart() {
      var variant = getVariant();
      var plan = getSelectedPlan();
      if (!variant.available || ctaButton.disabled) return;

      var params = new URLSearchParams();
      params.set('id', String(variant.id));
      params.set('quantity', String(getQuantity()));
      if (getPurchaseType() === 'subscribe' && plan) {
        params.set('selling_plan', plan.value);
      }

      ctaButton.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          Accept: 'application/json'
        },
        body: params.toString()
      })
        .then(function (response) {
          if (!response.ok) {
            return response.text().then(function (text) { throw new Error(text); });
          }
          updateCartCount();
          showSuccessModal();
        })
        .catch(function (error) {
          console.error('Error adding to cart:', error.message);
          alert('There was an issue adding the item to your cart');
        })
        .finally(function () {
          ctaButton.disabled = false;
          update();
        });
    }

    buybox.addEventListener('change', function (event) {
      // Choosing a frequency always means subscribing
      if (event.target.name === 'cc-buybox-selling-plan') {
        buybox.querySelector('input[name="cc-buybox-purchase-type"][value="subscribe"]').checked = true;
      }
      update();
    });

    successModal.addEventListener('click', function (event) {
      // Close on the backdrop or either close button
      if (event.target === successModal || event.target.closest('[data-cc-success-close]')) {
        hideSuccessModal();
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && successModal.style.display === 'flex') hideSuccessModal();
    });

    quantityInput.addEventListener('input', update);
    ctaButton.addEventListener('click', addToCart);

    // Pressing Enter in the quantity field would submit the product form through the
    // theme's own AJAX handler (without a selling plan), so route it through ours instead.
    productForm.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addToCart();
      },
      true
    );

    // The theme updates the master variant select without firing a change event,
    // so re-read it after any option selector changes.
    productForm.querySelectorAll('.single-option-selector').forEach(function (selector) {
      selector.addEventListener('change', function () {
        setTimeout(update, 0);
      });
    });
    if (variantSelect) variantSelect.addEventListener('change', update);

    update();
  }

  document.querySelectorAll('[data-cc-buybox]').forEach(initBuybox);
})();
